// extracted by mini-css-extract-plugin
module.exports = {"middleRow":"Home_middleRow__91lSm","thirdRow":"Home_thirdRow__3R1-D","half":"Home_half__3Zd_j","button":"Home_button__H4Kh_"};